<div nz-row nzJustify="center">
  <div class="container" nz-col nzSpan="15">
    <nz-skeleton [nzParagraph]="{ rows: 10 }" [nzLoading]="(isLoading$ | async) ?? false">
      <ng-container *ngIf="error$ | async as errorMsg; else result">
        <nz-result
          nzStatus="error"
          nzTitle="An error ocurred while fetching quick URLs"
          [nzSubTitle]="errorMsg"
        ></nz-result>
      </ng-container>
    </nz-skeleton>
  </div>
</div>

<ng-template #result>
  <div nz-row nzJustify="space-between" nzAlign="bottom">
    <div nz-col nzSpan="22">
      <nz-table
        #quickUrlTable
        [nzData]="(urls$ | async) ?? []"
        [nzShowPagination]="true"
        [nzShowSizeChanger]="true"
        [nzSize]="'small'"
        [nzPaginationPosition]="'both'"
      >
        <thead>
          <tr>
            <th>Label</th>
            <th>URL</th>
            <th>Accessible By</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let url of quickUrlTable.data | sort: 'label'; trackBy: trackByRef">
            <td>
              {{ url.label }}
            </td>
            <td>
              <a [href]="url.url" target="_blank">
                {{ url.url }}
              </a>
            </td>
            <td>
              <nz-tag *ngFor="let role of url.accessedBy | sort; trackBy: trackByRef">
                {{ role }}
              </nz-tag>
            </td>
            <td nz-row nzType="flex" nzJustify="space-around">
              <button nz-button (click)="editQuickUrl(url)">
                <i nz-icon nzType="edit" nzTheme="outline"></i>
              </button>
              <button
                nz-popconfirm
                nz-button
                nzIcon="delete"
                [nzLoading]="deleteLoading === url.shortname"
                nzPopconfirmPlacement="left"
                nzOkText="Confirm delete"
                [nzPopconfirmTitle]="'Are you sure you want to delete ' + url.label + '?'"
                (nzOnConfirm)="deleteQuickUrl(url.shortname)"
              >
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <div nz-row nzSpan="2">
      <button
        class="create-button"
        nz-button
        nzType="primary"
        nzShape="circle"
        nzSize="large"
        nz-tooltip
        nzTooltipTitle="Add Quick URL"
        (click)="createQuickUrl()"
      >
        <span nz-icon nzType="plus"></span>
      </button>
    </div>
  </div>
</ng-template>
